import React from 'react';

/**
 * The last row of a dish dropdown — on the TSR manual cards and the banquet rows —
 * for a dish that is not in Item Mapping (spec 2026-10-26-tsr-add-as-not-in-menu).
 * Choosing it marks the row "Not in Menu": it is recorded as a Not-in-Menu line and
 * resolved later in the Not in Menu worklist.
 *
 * onMouseDown keeps the input focused, so a click lands before the field's blur
 * closes the dropdown — the same guard the dish suggestions use.
 */
export default function AddAsNotInMenuOption({ typedName, active, onPick, onHover }) {
  return (
    <div
      className={`tsr-manual-suggestion tsr-nim-add-option${active ? ' active' : ''}`}
      onMouseEnter={onHover}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onPick}
      role="option"
      aria-selected={!!active}
    >
      <span className="tsr-manual-suggestion-name">{`➕ Add '${typedName}' as Not in Menu`}</span>
    </div>
  );
}
